<template>
  <div class="routes-map">
    <google-map
      @ready="googleMapReady"
      @geometry-clicked="lineStringClicked"
      @polyline-overlay-created="createLineString"
      ref="googleMap"
    ></google-map>
  </div>
</template>

<script>
import GoogleMap from '@/components/Maps/Google'

export default {
  name: 'routes-map',
  props: {
    routes: {
      type: Array,
      default: function () {
        return []
      }
    },
    drawingRoute: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mapIsReady: false
    }
  },
  computed: {
    lineStrings: function () {
      return this.routes.map(route => {
        const lineString = {
          path: [],
          id: route._id
        }
        for (const coordinate of route.geometry.coordinates) {
          lineString.path.push({
            lat: coordinate[1],
            lng: coordinate[0]
          })
        }
        return lineString
      })
    }
  },
  watch: {
    lineStrings: function () {
      this.updateMapRoutes()
    },
    drawingRoute: function () {
      this.updateMapDrawingState()
    }
  },
  components: {
    'google-map': GoogleMap
  },
  methods: {
    googleMapReady: function () {
      this.mapIsReady = true
      this.updateMapRoutes()
      this.updateMapDrawingState()
    },
    updateMapRoutes: function () {
      if (!this.mapIsReady) return false
      this.$refs.googleMap.removePolylines()
      for (const lineString of this.lineStrings) {
        this.$refs.googleMap.setGeometryToMap(this.$refs.googleMap.createPolyline({
          polylineOptions: lineString
        }))
      }
    },
    updateMapDrawingState: function () {
      if (!this.mapIsReady || !this.drawingRoute) return false
      this.$refs.googleMap.drawPolyline()
    },
    createLineString: function (overlayPath) {
      const lineString = {
        type: 'LineString',
        coordinates: []
      }
      for (const path of overlayPath) {
        const coordinate = [
          path.lng(),
          path.lat()
        ]
        lineString.coordinates.push(coordinate)
      }
      this.$emit('line-string-created', lineString)
    },
    lineStringClicked: function ({ type, id }) {
      if (type !== 'Polyline') return false
      this.$emit('line-string-clicked', id)
    }
  }
}
</script>

<style scoped>
.google-map {
  height: 100%;
  margin: 0;
  padding: 0;
}
.google-map-action {
  position: fixed;
  right: 53px;
  bottom: 23px;
  padding-top: 15px;
  margin-bottom: 0;
  z-index: 998;
}
</style>



// WEBPACK FOOTER //
// src/components/Maps/Routes.vue